<div
  class="dialog-footer"
  [attr.data-type]="type"
  [ngStyle]="dialogFooterStyle"
>
  <div class="button-group">
    @if (tertiaryButtonLabel) {
      <umss-button
        [label]="tertiaryButtonLabel"
        [variant]="tertiaryButtonVariant"
        [size]="buttonSize"
        [disabled]="tertiaryButtonDisabled"
        [leftIconName]="tertiaryButtonLeftIconName"
        [rightIconName]="tertiaryButtonRightIconName"
        [loading]="loading"
        (onClick)="handleTertiaryClick()"
      />
    }

    @if (secondaryButtonLabel) {
      <umss-button
        [label]="secondaryButtonLabel"
        [variant]="secondaryButtonVariant"
        [size]="buttonSize"
        [disabled]="secondaryButtonDisabled"
        [leftIconName]="secondaryButtonLeftIconName"
        [rightIconName]="secondaryButtonRightIconName"
        [loading]="loading"
        (onClick)="handleSecondaryClick()"
      />
    }

    @if (primaryButtonLabel) {
      <umss-button
        [label]="primaryButtonLabel"
        [variant]="primaryButtonVariant"
        [size]="buttonSize"
        [disabled]="primaryButtonDisabled"
        [leftIconName]="primaryButtonLeftIconName"
        [rightIconName]="primaryButtonRightIconName"
        [loading]="loading"
        (onClick)="handlePrimaryClick()"
      />
    }
  </div>
</div>
